function getFromElementVal(elementId) {
    const val = document.getElementById(elementId)?.value;
    if (val) {
        return val;
    } else {
        return null;
    }
}

function setFromElementVal(item, elementId) {
    const val = document.getElementById(elementId)?.value;
    if (val) {
        item.value = val;
    } else {
        item.value = null;
    }
}

function setBoolFromElementVal(item, elementId) {
    const val = document.getElementById(elementId)?.value;
    if (val) {
        item.value = ((val != 'False') && (val != 'false'));
    } else {
        item.value = false;
    }
}

function setNumberFromElementVal(item, elementId) {
    const val = document.getElementById(elementId)?.value;
    if (val) {
        item.value = Number(val);
    } else {
        item.value = 0;
    }
}


export {
    getFromElementVal,
    setFromElementVal,
    setBoolFromElementVal,
    setNumberFromElementVal
};